import React, {useState} from "react";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

// Material-UI
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
// Components
import Navbar from "../components/NavbarTitle";
import Background from "../components/BackgroundPattern";
import Footer from "../components/Footer";

//service
import uploadService from '../services/uploadService';
import userService from '../services/userService';
import { useEffect } from "react";

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  info: {
    margin: theme.spacing(2),
    "& .MuiAlert-icon": {
      fontSize: 40,
      padding: theme.spacing(1),
      margin: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        fontSize: 30,
        padding: theme.spacing(0),
        margin: theme.spacing(3, 2, 1, 1)
      }
    },
  },
  paper: {
    margin: theme.spacing(0, 2),
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 2),
    },
  },
  title: {
    paddingTop: theme.spacing(2),
    color: theme.palette.black.main
  },
  submit: {
    margin: theme.spacing(4, 0),
  },
  input: {
    width: "-webkit-fill-available",
    margin: theme.spacing(1, 0),
    padding: theme.spacing(2),
    border: "1px solid rgb(133, 133, 133)",
    borderRadius: "5px"
  }
}));

const CardInfoValidasi = ({ classes }) => {
  return (
    <section id="info-validasi">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert variant="filled" severity="warning" className={classes.info} elevation={3}>
            <AlertTitle>
              {
                "Untuk melanjutkan pendaftaran kegiatan Penerimaan Calon Anggota Baru KSR PMI Unit UNJ."
              }
            </AlertTitle>
            <Typography variant="body2" gutterBottom>
              {
                "1. Harap melakukan pembayaran biaya formulir sebesar Rp. 20.000 melalui DANA/OVO/GOPAY dengan Nomor 0812-1111-7691"
              }
            </Typography>
            <Typography variant="body2" gutterBottom>
              {
                "2. Unggah dan Kirim Bukti Pembayaran (ukuran file maksimal 1MB)"
              }
            </Typography>
            <Typography variant="body2" gutterBottom>
              {"3. Konfirmasi Pembayaran melalui WhatsApp 0812-1111-7691"}
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </section>
  );
};

const InfoTunggu = ({ classes }) => {
  return (
    <section id="info-tunggu">
      <Grid container className={classes.content}>
        <Grid item xs={12}>
          <Alert variant="filled" severity="warning" className={classes.info} elevation={3}>
            <AlertTitle style={{ paddingTop: 5 }}>
              {"PEMBAYARAN SEDANG DI VALIDASI"}
            </AlertTitle>
            <Typography variant="body2">
              {
                "Mohon tunggu, berkas sedang di validasi oleh Panitia PCAB KSR PMI Unit UNJ."
              }
            </Typography>
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Alert variant="filled" severity="info" className={classes.info} elevation={3}>
            <AlertTitle style={{ paddingTop: 5 }}>{"NARAHUBUNG"}</AlertTitle>
            <Typography variant="body2">
              {
                "Untuk Informasi lebih lanjut, dapat menghubungi Panitia PCAB KSR PMI Unit UNJ melalui WhatsApp dengan nomor +62857-8031-7112."
              }
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </section>
  );
};

const UnggahBuktiBayar = ({ classes }) => {
  const { register, handleSubmit } = useForm();
  // const history = useHistory();
  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append('bukti_bayar', data.buktiBayar[0]);
    formData.append('nominal', data.nominal);
    formData.append('jenis_bayar', 'pendaftaran');
    formData.append('id_user', localStorage.getItem('id_user'));

    uploadService.pembayaran(formData)
    .then ((response) => {
      return (
        Swal.fire({
          icon: "success",
          title: "Kirim Bukti Bayar Berhasil!",
          text: "Silahkan konfirmasi pembayaran melalui WhatsApp",
        }), window.location.reload()
      );
    })
    .catch((err) => {
      console.log(err.response)
      return (
        Swal.fire({
          icon: "error",
          title: "Kirim Bukti Bayar Gagal!",
          text: "Hubungi kami melalui WhatsApp",
        })
      );
    })

  }

  return (
    <section id="unggah-bukti-bayar">
      <Paper elevation={5} className={classes.paper}>
        <Container>
          <Typography
            className={classes.title}
            variant="h4"
            align="center"
            gutterBottom
          >
            {"Unggah Bukti Pembayaran"}
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  id="nominalBayar"
                  name="nominalBayar"
                  inputRef={register({ required: true })}
                  label="Nominal Pembayaran"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  placeholder="20000"
                  fullWidth
                />
                <input 
                  id="buktiBayar"
                  name="buktiBayar"
                  ref={register({ required: true })}
                  type="file"
                  accept="image/png, image/jpeg"
                  className={classes.input}
                />
                <Typography variant="caption" align="center" color="primary">
                  {"Unggah Bukti Pembayaran (ukuran maksimal 1MB)"}
                </Typography>
                <Button
                  className={classes.submit}
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                  fullWidth
                >
                  {"Kirim Bukti Pembayaran"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>
    </section>
  );
};

const CardInfo = ({ classes }) => {
  let savedTahapInfo = localStorage.getItem('tahap');
  const [showTahapUser, setTahapUser] = useState(savedTahapInfo);

  useEffect(() => {
    userService.getUserInfo()
    .then((response) => {
      setTahapUser(response.data.tahap);
      localStorage.setItem('tahap', response.data.tahap);
    })
    .catch(e => {
      console.log(e)
      return (
        window.location.reload()
      )
    })
  }, [setTahapUser]);

  switch(showTahapUser) {
    case "0":
      return(
        <div>
          <CardInfoValidasi classes={classes} />
          <UnggahBuktiBayar classes={classes} />
        </div>
      )
    default:
      return (
        <InfoTunggu classes={classes}/>
      )
  }

}

const ValidasiPembayaran = () => {
  const classes = useStyle();
  return (
    <section id="validasi-pembayaran" className={classes.container}>
      <Background/>
      <Navbar title="VALIDASI PEMBAYARAN PENDAFTARAN" />
      <Container style={{flex: "1"}}>
        <CardInfo classes={classes}/>
        {/* <CardInfoValidasi classes={classes} />
        <UnggahBuktiBayar classes={classes} /> */}
      </Container>
      <Footer />
    </section>
  );
};

export default ValidasiPembayaran;
